<div class="gap-top" style="padding-right: 70px;">
  <div style="
    background-color: #26293b;
    width: 60%;
    padding: 10px 10px;
    margin: auto auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);">
    <h1 class="text-center text-default" style="
      margin-top: 20px;
      text-transform: uppercase;">
      Verify your password
    </h1>
    <hr>
    <div *ngIf="verification == false; else verified;">
      <p class="text-center text-default">
        <b>Click the button</b> below to receive system generated password on your email.
      </p>
      <div style="
        width: 100%;
        text-align: center;
        margin-bottom: 25px;">
        <a class="btn btn-success"
          (click)="verifyResetToken()">
          Verify
        </a>
      </div>
    </div>
    <ng-template #verified>
      <div style="
        width: 100%;
        text-align: center;">
        <mat-icon style="font-size: 80px; margin-left:-6%;" class="text-success">verified_user</mat-icon>
      </div>
      <p class="text-center text-default">
        Email has been sent! <br>
        <b>Redirecting to Login page...</b>
      </p>
    </ng-template>
  </div>
</div>